export default "__VITE_ASSET__s_aR_5Qx__"